export default __webpack_public_path__ + "static/architecture-32c4f9dd9acf157d5863f0f7ad82dbd0.webp";